import { all } from 'redux-saga/effects';
import { loginPageWatcherSaga } from './containers/LoginPage/saga';
import { usersPageWatcherSaga } from './containers/UsersPage/saga';
import { sideBarSagaWatcher } from './components/SideBar/saga';

export default function* rootSaga() {
  yield all([loginPageWatcherSaga(), usersPageWatcherSaga(), sideBarSagaWatcher()]);
}
